module.exports = __webpack_public_path__ + "static/media/19_l_ugol_0_5.46.29f19e30.png";